// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"59a88eb9","186":"924c8a36","272":"ede2255f","372":"330cf997","377":"7e98472d","738":"b289736a","841":"f153c506","851":"b309ecce","856":"b9b9737e"}[chunkId] + ".chunk.js";
};